// extracted by mini-css-extract-plugin
export default {"shimmering":"styles_shimmering__ws4E4","textShine":"styles_textShine__uaK5z"};